import { StyleSheet } from 'react-native';

const PURPLE = '#7C3AED';

export default StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
    elevation: 1000,
    backgroundColor: '#1E1E1E',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 40,
  },
  keypadOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
    elevation: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeBtn: {
    position: 'absolute',
    top: 40,
    left: 40,
    width: 44,
    height: 44,
    borderRadius: 22,
    borderWidth: 1,
    borderColor: '#444',
    backgroundColor: '#333',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeBtnText: {
    fontSize: 20,
    color: '#fff',
    fontWeight: '500',
  },
  body: {
    width: '100%',
    maxWidth: 800,
    alignItems: 'center',
  },
  totalLabel: {
    fontSize: 14,
    lineHeight: 20,
    color: '#999',
    fontWeight: '500',
    textAlign: 'center',
  },
  totalAmount: {
    fontSize: 36,
    lineHeight: 44,
    color: '#fff',
    fontWeight: '700',
    textAlign: 'center',
    marginTop: 4,
  },
  heading: {
    fontSize: 20,
    lineHeight: 28,
    color: '#fff',
    fontWeight: '700',
    textAlign: 'center',
    marginTop: 32,
    marginBottom: 20,
  },
  cardsRow: {
    flexDirection: 'row',
    width: '100%',
    gap: 12,
  },
  card: {
    flex: 1,
    height: 90,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    backgroundColor: '#333',
    borderWidth: 1,
    borderColor: '#444',
  },
  cardSelected: {
    backgroundColor: PURPLE,
    borderColor: PURPLE,
  },
  cardLabel: {
    fontSize: 14,
    lineHeight: 20,
    textAlign: 'center',
    color: '#999',
    fontWeight: '500',
  },
  cardLabelSelected: {
    color: '#fff',
  },
  cardAmount: {
    fontSize: 20,
    lineHeight: 28,
    textAlign: 'center',
    color: '#fff',
    fontWeight: '600',
    marginTop: 2,
  },
  cardAmountSelected: {
    color: '#fff',
  },
  actions: {
    width: '100%',
    marginTop: 40,
  },
  confirmBtn: {
    backgroundColor: PURPLE,
    height: 56,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  confirmBtnText: {
    fontSize: 16,
    color: '#fff',
    fontWeight: '600',
  },
  skipBtn: {
    backgroundColor: '#333',
    height: 56,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#444',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 10,
  },
  skipBtnText: {
    fontSize: 16,
    color: '#999',
    fontWeight: '500',
  },
  keypadContainer: {
    width: 320,
    backgroundColor: '#1E1E1E',
    borderRadius: 12,
    padding: 24,
    alignItems: 'center',
  },
  keypadTitle: {
    fontSize: 16,
    color: '#fff',
    fontWeight: '600',
    marginBottom: 16,
  },
  keypadDisplay: {
    fontSize: 32,
    color: '#fff',
    fontWeight: '700',
    marginBottom: 20,
    textAlign: 'center',
  },
  keypadGrid: {
    width: '100%',
    gap: 8,
  },
  keypadRow: {
    flexDirection: 'row',
    gap: 8,
  },
  keypadBtn: {
    flex: 1,
    height: 56,
    borderRadius: 8,
    backgroundColor: '#333',
    alignItems: 'center',
    justifyContent: 'center',
  },
  keypadBtnText: {
    fontSize: 20,
    color: '#fff',
    fontWeight: '600',
  },
  keypadConfirmBtn: {
    flex: 1,
    height: 56,
    borderRadius: 8,
    backgroundColor: PURPLE,
    alignItems: 'center',
    justifyContent: 'center',
  },
  keypadCancelBtn: {
    flex: 1,
    height: 56,
    borderRadius: 8,
    backgroundColor: '#444',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
